import React from 'react'
import cn from 'classnames'
import _ from 'lodash'

let Pager = ({ page, pageCount, setPage }) =>
  pageCount <= 1 ? null : (
    <ul className="pagination pagination-sm">
      <li className="page-item">
        <button
          className="page-link"
          disabled={page === 0}
          onClick={() => setPage(page - 1)}
        >
          Previous
        </button>
      </li>
      {_.times(pageCount, t => (
        <li
          key={t}
          className={cn('page-item', {
            active: page === t,
          })}
        >
          <button className="page-link" onClick={() => setPage(t)}>
            {t + 1}
          </button>
        </li>
      ))}
      <li className="page-item">
        <button
          className="page-link"
          disabled={pageCount === page + 1}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </li>
    </ul>
  )

export default Pager
